export default __webpack_public_path__ + "static/media/line10.bd1bab51.svg";